import { render } from "./Websocketevents.vue?vue&type=template&id=26cc0f72"
import script from "./Websocketevents.vue?vue&type=script&lang=js"
export * from "./Websocketevents.vue?vue&type=script&lang=js"

import "./Websocketevents.vue?vue&type=style&index=0&id=26cc0f72&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__